<template>
  <section class="section-input-container">
    <div class="FlightNumberBox">
      <div class="flex-center db-box">
        <div class="db-md-input mg-r-10">
          <el-input
            ref="input1"
            v-model="Num.First"
            :name="name"
            placeholder="e.g. CX"
            class="v-input"
            :maxlength="2"
            :disabled="disabled"
            :keyNonChinese="true"
            key-az
            @input="ChangeInput('First',2,$event)"
            @focus="onFocus(1)"
            @keyup.native="onKeyUp"
            @keydown.native="onKeyDown('First',$event)"
            @blur="handlerBlur"
          ></el-input>
        </div>
        <div class="db-lar-input">
          <el-input
            ref="input2"
            v-model="Num.Last"
            placeholder="e.g. 601"
            type="number"
            class="v-input"
            :maxlength="4"
            :disabled="disabled"
            :keyNumber="true"
            @input="ChangeInput('Last',4,$event)"
            @focus="onFocus(2)"
            @keyup.native="onKeyUp"
            @keydown.native="onKeyDown('Last',$event)"
            @blur="handlerBlur"
          ></el-input>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import {filterChinese, toInteger} from '@/util/common'

export default {
  name: '',
  components: {},
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    rules: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errTips: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      FlightNumber: '',
      Num: {
        First: '',
        Last: '',
      },
      FocusIndex : 0,
      iskeydown : false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(data) {
        // console.log(data)
        if(data != this.FlightNumber){
          if(data) {
            // 数据填充处理
            const num = data.split(' ')
            const f = num[0]
            const l =  num[1]
            this.Num.First = f
            this.Num.Last = l
            this.FlightNumber = `${f} ${l}`
          }
          else {
            this.Num.First = ''
            this.Num.Last = ''
            this.FlightNumber = ''
          }
        }
      }
    },
    'Num.First': {
      immediate: true,
      handler(val) {
        if(val == null || val === '') {
          // this.$emit('input', '')
          this.Num.First = ''
        }
        else {
          let currentValue = val
          let newValue = String(currentValue)
          // newValue = filterChinese(newValue)
          const pat =  /^[A-Za-z0-9]+$/
          const patResult = newValue.match(pat)
          newValue = patResult ? patResult.join('') : ''

          if(newValue !== val) {
            this.inputValue = newValue
          }
          this.Num.First = String(newValue).toUpperCase()
        }
      },
    },
  },
  mounted() {
  },
  methods: {
    onKeyUp(){
      this.iskeydown = false
    },
    onKeyDown(key,e){
      this.iskeydown = true
      const prevIndex = this.FocusIndex - 1
      let val = this.Num[key] + ''
      if(e.keyCode == 8){
        // console.log(val)
        e.preventDefault()
        if(val){
          this.Num[key] = val.substring(0,val.length - 1)
        }else{
          this.FocusIndex = prevIndex < 1 ? 1 : prevIndex
          this.$refs[`input${this.FocusIndex}`].focus()
        }
      }
    },
    ChangeInput(key,len,$event){
      let str = $event + ''
      if(this.iskeydown){
        if(str.length >= len){
          this.Num[key] = str.slice(0,len)
          let newNextVal = str.slice(len)
          let index = this.FocusIndex + 1
          this.FocusIndex = index > 2 ? 2 : index
          let oldNextVal = this.$refs[`input${this.FocusIndex}`].value
          this.$refs[`input${this.FocusIndex}`].focus()
          this.$nextTick(() => {
            if(!oldNextVal){
              // 没有旧数据
              let nextKey = Object.keys(this.Num)[this.FocusIndex - 1]
              this.Num[nextKey] = newNextVal
            }
          })

        }
      }else{
        return
      }
    },
    onFocus(index){
      this.FocusIndex = index
    },
    handlerBlur() {
      const { First, Last } = this.Num
      if(First&&Last){
        this.FlightNumber = `${First} ${Last}`
      }
      else{
        this.FlightNumber = ''
      }
      this.$emit('input', this.FlightNumber)
    }
  }
}
</script>

<style scoped lang="scss">
.v-FlightNumber-group {
  overflow: unset;
  &.van-field--error{
    /deep/ .v-input{
      .van-field__control{
        box-shadow: 0 0 0 0.1875rem #ffd5d5;
        border: 0.0625rem solid #E42424;
        color: #012a63;
      }
    }
  }
}
.FlightNumberBox,.db-box{
  width: 100%;
}
.db-box {
  flex-wrap: wrap;
}
.db-lar-input {
  // width: 120px;
  flex: 1;
}
.db-md-input {
  width: 90px;
}
</style>
